import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(advancedFormat);
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

const convertDateToUTCString = (date) => {
  return dayjs.utc(dayjs(date).format('YYYY-MM-DDTHH:mm:ss')).format();
};

export { dayjs, convertDateToUTCString };
